import api from "../api/api"

export default class {
    constructor(baseUrl) {
        this.state = {
            baseUrl: baseUrl,
            loading: false,
            loaded: false,
            deleteLoading: false,
            items: null,
            currentItem: null,
        };
        this.mutations = {
            SET_ITEMS(state, items) {
                state.items = items
            },
            SET_PARAMETER(state, {value, item, parameter}) { //TODO code duplication from basestore.js
                if (isNaN(parseFloat(value))) {
                    item[parameter] = value
                } else {
                    item[parameter] = parseFloat(value)
                }
            },
            TOGGLE_LOADING(state) {
                state.loading = !state.loading
            },
            TOGGLE_DELETE_LOADING(state) {
                state.deleteLoading = !state.deleteLoading
            },
            SET_LOADED(state, loaded = true) {
                state.loaded = loaded
            },
            SET_CURRENT_ITEM(state, item) {
                state.currentItem = item
            },
        };
        this.actions = {
            async fetchItem(context, id) {
                let url = context.state.baseUrl + `${id}/`
                let response = await api.get(url);
                context.commit('SET_CURRENT_ITEM', response.data);
            },
            async fetchAll(context, searchId = -1) {
                context.commit('TOGGLE_LOADING')
                let search = searchId !== -1 ? '?search=' + searchId : null
                let url = context.state.baseUrl + search
                let response = await api.get(url)
                context.commit('SET_ITEMS', response["data"])
                context.commit('TOGGLE_LOADING')

                if (response['data'].features.length > 0) {
                    context.commit('SET_LOADED')
                }
            },
            setParameter(context, payload) {
                context.commit('SET_PARAMETER', payload)
            },
            async upload(context, formData) {
                let response = await api.post(
                    `${context.state.baseUrl}${context.rootState.project.currentProject.id}/upload/`,
                    formData
                )
                if (response['data'].features.length > 0) {
                    context.commit('SET_LOADED')
                }
                context.commit('SET_ITEMS', response.data)
            },
            async generate(context, payload) {
                payload.properties.project = context.rootState.project.currentProject.id
                let response = await api.post(
                    `${context.state.baseUrl}${context.rootState.project.currentProject.id}/generate/`, payload)
                if(response.status === 202 || response.status === 201) {
                    context.commit('SET_LOADED')
                }
                if (response['data'].features?.length > 0) {
                    context.commit('SET_LOADED')
                }
                context.commit('SET_ITEMS', response.data)
            },

            async deleteAll(context) {
                context.commit('TOGGLE_DELETE_LOADING')
                try {
                    await api.delete(
                        `${context.state.baseUrl}${context.rootState.project.currentProject.id}/delete/`,
                    )
                    context.dispatch('resetState')
                } catch {
                    context.commit('TOGGLE_DELETE_LOADING')
                }

            },
            setCurrentItem(context, payload) {
                context.commit("SET_CURRENT_ITEM", payload);
            }
        };
    }
}